


export default class ButtonComponent extends HTMLElement {
    
    #startIconPath;
    #endIconPath;
    #labelText;

    constructor() {
      super();
    }    

    set disabled(v) {
        v ? this.setAttribute("disabled",""): this.removeAttribute("disabled"); 
    }

    get disabled() {
        return this.getAttribute("disabled");
    }

    get startIconPath() {
        if (this.#startIconPath == undefined) {
            return "";
        }
        return this.#buildSvgContainer("start-icon", this.#startIconPath);
    }

    set startIconPath(path) {
        this.#startIconPath = path;
        this.render();
    }
    
    get endIconPath() {
        if (this.#endIconPath == undefined) {
            return "";
        }
        return this.#buildSvgContainer("end-icon", this.#endIconPath);
    }

    set endIconPath(path) {
        this.#endIconPath = path;
        this.render();
    }

    get labelText() {
        if (this.#labelText == undefined) {
            return "";
        }
        return this.#labelText;
    }

    set labelText(text) {
        this.#labelText = text;
        this.render();
    }

    #buildSvgContainer(type, path) {
           return  `<svg height="24" class="v24-scheduler-${type}" version="1.1" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path d="${path}"></path>
                </svg>`
    }

    render() {
        this.classList.add("btn");
        this.classList.add("v24SchedulerButton");
        this.innerHTML = `${this.startIconPath} ${this.labelText}${this.endIconPath}`;
    }
}
